var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { ref: "containerGradientRef", staticClass: "c-gradient-picker" },
    [
      _c(
        "div",
        { staticClass: "c-gradient-picker__header" },
        [
          _c(_setup.CDropdown, {
            staticClass: "w-50",
            attrs: {
              options: _setup.getGradientTypes,
              value: _setup.gradientType,
              name: "gradientType",
              disabled: true,
              placeholder: "Select Gradient Type",
            },
            on: { input: _setup.onGradientTypeChange },
          }),
          _vm._v(" "),
          _c(_setup.CInput, {
            staticClass: "c-gradient-picker__angle-input",
            attrs: {
              min: 0,
              max: 180,
              label: "",
              type: "number",
              "input-size": "sm",
            },
            on: { input: _setup.onUpdateAngle },
            scopedSlots: _vm._u([
              {
                key: "append",
                fn: function () {
                  return [_c("span", [_vm._v("°")])]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _setup.gradientAngle,
              callback: function ($$v) {
                _setup.gradientAngle = $$v
              },
              expression: "gradientAngle",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "containerRef",
          staticClass: "c-gradient-picker__canvas",
          on: { dblclick: _setup.addColorStop },
        },
        [
          _c("div", { staticClass: "c-gradient-picker__bar" }, [
            _c("div", {
              staticClass: "c-gradient-picker__bar-fill",
              style: _setup.gradientStyle,
            }),
          ]),
          _vm._v(" "),
          _vm._l(_setup.gradientColorStopList, function (stop, index) {
            return _c(
              "div",
              {
                key: `picker-${index}`,
                staticClass: "c-gradient-picker__stop",
                class: { active: _setup.selectedStopIndex === index },
                style: { left: _setup.getGradientStopPosition(stop.offset) },
                on: {
                  mousedown: function ($event) {
                    $event.stopPropagation()
                    return _setup.startDragging(index, $event)
                  },
                },
              },
              [
                _c("div", {
                  staticClass: "c-gradient-picker__stop-handle",
                  style: _setup.innerStopBackground(stop.hex),
                }),
              ]
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "c-gradient-picker__stops" }, [
        _c(
          "div",
          { staticClass: "c-gradient-picker__stops-header" },
          [
            _c("h3", [_vm._v("Stops")]),
            _vm._v(" "),
            _c(_setup.CButton, {
              attrs: { size: "icon", icon: "plus" },
              on: { click: () => _setup.addColorStop() },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "c-gradient-picker__stops-list" },
          _vm._l(_setup.sortedGradientStops, function (stop) {
            return _c(
              "div",
              {
                key: `list-${stop.index}`,
                staticClass: "c-gradient-picker__stops-item",
                class: { active: _setup.selectedStopIndex === stop.index },
                attrs: { "data-index": stop.index },
              },
              [
                _c(_setup.CInput, {
                  attrs: {
                    value: stop.offset,
                    "input-size": "sm",
                    min: 0,
                    max: 100,
                    type: "number",
                  },
                  on: { input: (e) => _setup.onOffsetChange(stop, e) },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "c-gradient-picker__stops-color" }, [
                  _c("div", {
                    staticClass: "c-gradient-picker__stops-preview",
                    style: { backgroundColor: stop.hex },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return (() =>
                          _setup.openColorPickerPopper(stop.index)).apply(
                          null,
                          arguments
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(stop.hex.replace("#", "").toUpperCase())),
                  ]),
                ]),
                _vm._v(" "),
                _c(_setup.CButton, {
                  attrs: {
                    disabled: !_setup.canDeleteStop,
                    size: "icon",
                    icon: "trash-can",
                  },
                  on: { click: () => _setup.onDeleteStop(stop.index) },
                }),
              ],
              1
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { ref: "solidColorRef", staticClass: "color-selector-wrapper" },
        [
          _setup.openColorPicker
            ? _c(_setup.CSolidColor, {
                staticClass: "color-picker",
                attrs: { mode: _vm.mode },
                on: { input: _setup.onUpdateColor },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "d-flex justify-content-end mt-auto",
                            },
                            [
                              _c(_setup.CButton, {
                                staticClass: "mr-2",
                                attrs: {
                                  variant: "outline-primary",
                                  size: "sm",
                                  text: "CANCEL",
                                },
                                on: { click: _setup.onClosePopper },
                              }),
                              _vm._v(" "),
                              _c(_setup.CButton, {
                                attrs: {
                                  variant: "primary",
                                  size: "sm",
                                  text: "APPLY",
                                },
                                on: { click: _setup.onClosePopper },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  104726877
                ),
                model: {
                  value: _setup.currentColor,
                  callback: function ($$v) {
                    _setup.currentColor = $$v
                  },
                  expression: "currentColor",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }